import { cn } from '@/shared/lib/cn';

export type PillColor =
  | 'primary'
  | 'cerulean'
  | 'pine'
  | 'sky'
  | 'success'
  | 'warning'
  | 'danger'
  | 'neutral';

export const PILL_TONE: Record<PillColor, string> = {
  primary: 'bg-primary-tint text-primary-ink',
  cerulean: 'bg-cerulean-900 text-cerulean-100',
  pine: 'bg-pine-900 text-pine-100',
  sky: 'bg-sky-900 text-sky-100',
  success: 'bg-success-tint text-success',
  warning: 'bg-warning-tint text-warning-ink',
  danger: 'bg-danger-tint text-danger',
  neutral: 'bg-neutral-tint text-ink-muted',
};

const ACTIVE_RING: Record<PillColor, string> = {
  primary: 'ring-primary',
  cerulean: 'ring-cerulean',
  pine: 'ring-pine',
  sky: 'ring-sky',
  success: 'ring-success',
  warning: 'ring-warning',
  danger: 'ring-danger',
  neutral: 'ring-neutral',
};

export const pillTone = (active: boolean, color: PillColor = 'primary') =>
  active
    ? cn(PILL_TONE[color], 'ring-2', ACTIVE_RING[color], 'shadow-sm')
    : 'bg-neutral-tint text-ink-muted hover:ring-1 hover:ring-neutral';
